import { render, staticRenderFns } from "./FcfKyc.vue?vue&type=template&id=13947954&scoped=true&"
import script from "./FcfKyc.vue?vue&type=script&lang=js&"
export * from "./FcfKyc.vue?vue&type=script&lang=js&"
import style0 from "./FcfKyc.vue?vue&type=style&index=0&id=13947954&scoped=true&lang=css&"
import style1 from "./FcfKyc.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13947954",
  null
  
)

export default component.exports